import { useState } from 'react';

import { Button, FormField, Input, Label, Text } from '@zillow/constellation-10';
import { useRentalManagerUserPropertyDeleteWebApiHandler_delete } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import type { ChangeEvent } from 'react';

type Props = {
  listingAlias: string;
  isSubmitDisabled?: boolean;
  onStartSubmit?: () => void;
};

const DeleteButton = ({ listingAlias, isSubmitDisabled, onStartSubmit }: Props) => {
  const [deletePropertyReason, setDeletePropertyReason] = useState('');

  const { mutate: deleteProperty } = useRentalManagerUserPropertyDeleteWebApiHandler_delete({});

  const handleDeletePropertySubmit = () => {
    if (window.confirm(`Are you sure you want to permanently delete that listing?`)) {
      onStartSubmit && onStartSubmit();
      deleteProperty(
        {
          getParams: {
            listingAlias,
            reason: deletePropertyReason,
          },
        },
        {
          onSuccess: () => {
            window.location.href = '/rental-manager/properties';
          },
        },
      );
    }
  };

  return (
    <div data-testid="DeleteButton">
      <Text textStyle="body-sm-bold">Need to permanently delete this listing?</Text>

      <FormField css={{ marginBlock: '300' }}>
        <Label>Reason for deletion</Label>

        <Input onChange={(e: ChangeEvent<HTMLInputElement>) => setDeletePropertyReason(e.target.value)} />
      </FormField>

      <Button
        tone="brand"
        emphasis="outlined"
        onClick={handleDeletePropertySubmit}
        disabled={isSubmitDisabled || deletePropertyReason === ''}
        fluid
        css={{ paddingBlock: '200' }}
      >
        Delete property
      </Button>
    </div>
  );
};

export default DeleteButton;
